import React, { FC } from 'react';
import { FormControl, Grid, MenuItem, Select, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { LocalAudioTrack } from 'twilio-video';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';
import LocalAudioLevelIndicator from '../LocalAudioLevelIndicator/LocalAudioLevelIndicator';
import { SELECTED_AUDIO_INPUT_KEY } from '../../constants';
import useDevices from '../../hooks/useDevices/useDevices';
import useMediaStreamTrack from '../../hooks/useMediaStreamTrack/useMediaStreamTrack';

const LocalAudioPreview: FC = () => {
    const { t } = useTranslation();
    const { localTracks } = useVideoContext();
    const { audioInputDevices } = useDevices();
    const localAudioTrack = localTracks.find(track => track.kind === 'audio') as LocalAudioTrack;
    const mediaStreamTrack = useMediaStreamTrack(localAudioTrack);
    const localAudioInputDeviceId = mediaStreamTrack?.getSettings().deviceId;

    function replaceTrack(newDeviceId: string) {
        window.localStorage.setItem(SELECTED_AUDIO_INPUT_KEY, newDeviceId);
        localAudioTrack?.restart({ deviceId: { exact: newDeviceId } });
    }

    return (
        <Grid container xs={12} direction="column">
            <Typography variant="h5">{t('Current Audio Device')}</Typography>

            {audioInputDevices.length > 1 ? (
                <FormControl fullWidth>
                    <Grid
                        container
                        direction="row"
                        xs={6}
                        justify="flex-start"
                        alignContent="center"
                        alignItems="center"
                    >
                        <Grid item xs={9}>
                            <Select
                                onChange={e => replaceTrack(e.target.value as string)}
                                value={localAudioInputDeviceId || ''}
                                variant="outlined"
                                fullWidth
                            >
                                {audioInputDevices.map((device: MediaDeviceInfo) => (
                                    <MenuItem value={device.deviceId} key={device.deviceId}>
                                        {device.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Grid>
                        <Grid
                            container
                            item
                            xs={2}
                            direction="row"
                            justify="center"
                            alignContent="center"
                            alignItems="center"
                        >
                            <Grid>
                                <LocalAudioLevelIndicator />
                            </Grid>
                        </Grid>
                    </Grid>
                </FormControl>
            ) : (
                <Typography>{localAudioTrack?.mediaStreamTrack.label || 'No Local Audio'}</Typography>
            )}
        </Grid>
    );
};

export default LocalAudioPreview;
